import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Select, DatePicker, Button, Radio } from "antd";
import dayjs from "dayjs";

import { useProjectState } from "../../../context/stateContext";
import tableEfficiencyAction from "../../../redux/tablesEfficiency/actions";
import "./index.css";

const { Option } = Select;
const { getTablesEfficiencyData } = tableEfficiencyAction;

const TablesEfficiencyActions = () => {
  const {
    selectedOrganization,
    allSectedRestaurants,
    setAllSelectedRestaurants,
  } = useProjectState();
  const dispatch = useDispatch();
  const { restaurants, organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );

  const [date, setDate] = useState(dayjs());
  const [period, setPeriod] = useState("all"); // нов state за радио бутоните

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );

  const defaultTouchSaleRestaurantId =
    defaultOrganization[0]?.defaultTouchSaleRestaurantId;
  useEffect(() => {
    if (defaultOrganization.length > 0) {
      setAllSelectedRestaurants([
        defaultOrganization[0]?.defaultTouchSaleRestaurantId,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization, defaultTouchSaleRestaurantId]);

  useEffect(() => {
    window.localStorage.setItem("restaurantId", allSectedRestaurants);
    const timer = setTimeout(() => {
      const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : "";

      const params = {
        date: formattedDate,
        selectedRestaurant: allSectedRestaurants,
      };

      if (period === "lunch") {
        params.startTime = "09:00";
        params.endTime = "16:00";
      } else if (period === "dinner") {
        params.startTime = "16:00";
        params.endTime = "23:59";
      }

      dispatch(getTablesEfficiencyData(params));
    }, 1000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allSectedRestaurants, selectedOrganization, date, period]);

  const onChange = (value) => {
    setDate(value);
  };

  const handlePrevDay = () => {
    setDate((prev) => dayjs(prev).subtract(1, "day"));
  };

  const handleNextDay = () => {
    setDate((prev) => dayjs(prev).add(1, "day"));
  };

  const handlePeriodChange = (e) => {
    setPeriod(e.target.value);
    // Тук можеш да добавиш логика за fetch/filter по период, ако е нужно
  };

  return (
    <div className="tables-efficiency-action-buttons-container">
      {defaultOrganization[0]?.multipleRestaurants && (
        <Select
          showSearch={false}
          virtual={false}
          key="tablesEfficiencySelect"
          placeholder="Изберете ресторант"
          value={allSectedRestaurants[0] || undefined}
          onChange={(value) => setAllSelectedRestaurants([value])}
          className="tables-efficiency-action-buttons"
        >
          {restaurants?.map((restaurant) => (
            <Option
              key={restaurant.id}
              value={restaurant.id}
              className="tables-efficiency-action-select-option"
            >
              {restaurant.name}
            </Option>
          ))}
        </Select>
      )}
      <div className="tables-efficiency-date-picker">
        <Button onClick={handlePrevDay}>-</Button>
        <DatePicker value={date} onChange={onChange} />
        <Button onClick={handleNextDay}>+</Button>
        <Radio.Group
          style={{ marginLeft: 16 }}
          value={period}
          onChange={handlePeriodChange}
        >
          <Radio value="all">Целият ден</Radio>
          <Radio value="lunch">Обяд</Radio>
          <Radio value="dinner">Вечер</Radio>
        </Radio.Group>
      </div>
    </div>
  );
};

export default TablesEfficiencyActions;
